import { useQuery } from '@tanstack/react-query';

import { useRequest, type QueryFunction, type RequestQuery } from '../common';
import { getAccountsKey } from './keys';

// The selection is expressed the same way as it is for a bulk update: either an
// explicit list of account ids, or the applyToAll flag to mean every account
// owned by the active group.
export type AccountSelection = {
  accounts?: number[];
  applyToAll?: boolean;
};

export type AccountTaxSummary = {
  isTaxExemptMixed: boolean;
  isTaxRateMixed: boolean;
  taxExempt: boolean | null;
  taxRate: string | null;
};

export const getAccountTaxSummaryKey = () =>
  [...getAccountsKey(), 'taxSummary'] as const;

export const getAccountTaxSummaryQueryKey = (
  query?: RequestQuery<AccountSelection>,
) => [...getAccountTaxSummaryKey(), query] as const;

export const useAccountTaxSummary: QueryFunction<
  AccountTaxSummary,
  [],
  ReturnType<typeof getAccountTaxSummaryQueryKey>,
  AccountSelection
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getAccountTaxSummaryQueryKey(query),
    queryFn: ({ signal }) =>
      request<AccountTaxSummary>('/accounts/tax_summary', {
        query,
        init: { signal },
      }),
  });
};
